import Icon from '../components/Icon.vue'

Icon.register({
  bed: {
    width: 640,
    height: 512,
    paths: [
      {
        d: 'M176 256C220.1 256 256 220.1 256 176S220.1 96 176 96 96 131.9 96 176 131.9 256 176 256zM528 128H304C295.2 128 288 135.2 288 144V288H64V80C64 71.2 56.8 64 48 64H16C7.2 64 0 71.2 0 80V432C0 440.8 7.2 448 16 448H48C56.8 448 64 440.8 64 432V384H576V432C576 440.8 583.2 448 592 448H624C632.8 448 640 440.8 640 432V240C640 178.1 589.9 128 528 128z'
      }
    ]
  }
})
